import React from "react";
import styled from "@emotion/styled";
import { compose, position, layout, typography } from "../../utils/styleFn";
import { Box, BoxProps, themeGet } from "../../";
import { EmotionComponent } from "../../styled";

export type NotificationBadgeProps = {
  /** Text to display in notification badge */
  text?: string | number;
  /** Absolute top value of the notification badge */
  absTop?: string;
  /** Absolute right value of the notification badge */
  absRight?: string;
} & BoxProps;

const styleProps = compose(position, layout, typography);

const Badge: EmotionComponent<NotificationBadgeProps> = styled(
  Box
)<NotificationBadgeProps>`
  position: absolute;
  min-width: 19px;
  color: white;
  line-height: 19px;
  text-align: center;
  border-radius: 50%;
  background: ${themeGet("colors.error")};
  ${(props) => `
      top: ${props.absTop || "-5px"};
      right: ${props.absRight || "-8px"};
    `}
  ${(props) => (props.fontSize ? "" : "font-size: 12px;")};
  ${styleProps}
`;

export const NotificationBadge: React.FC<NotificationBadgeProps> = ({
  text,
  ...props
}) => <Badge {...props}>{text}</Badge>;

export default NotificationBadge;
